import { render } from "./page-eprocurement.vue?vue&type=template&id=00e1605a&scoped=true"
import script from "./page-eprocurement.vue?vue&type=script&lang=js"
export * from "./page-eprocurement.vue?vue&type=script&lang=js"

import "./page-eprocurement.vue?vue&type=style&index=0&id=00e1605a&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e1605a"]])

export default __exports__